module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BJ-3927cf5df89ceb379e16743ee365f0ec.png";